<template>
  <layout min-width="428">
    <template slot="header"> {{ isNew ? 'Add' : 'Edit' }} data type </template>

    <template>
      <v-form class="mx-4" ref="form" v-model="isValid">
        <subheader>General info</subheader>
        <v-text-field
          v-model="localEntity.name"
          label="Name *"
          clearable
        ></v-text-field>
        <v-textarea
          label="Description"
          v-model="localEntity.description"
          no-resize
          rows="1"
          auto-grow
        ></v-textarea>
        <v-textarea
          label="Schema(JSON)"
          v-model="localEntity.schema"
          no-resize
          rows="1"
          auto-grow
        ></v-textarea>
      </v-form>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text @click="close">
        cancel
      </v-btn>
      <v-btn color="primary" text @click="save" :loading="isLoading">
        <template v-if="isNew">add</template>
        <template v-else>save</template>
      </v-btn>
    </template>
  </layout>
</template>

<script>
import { computed, onMounted, reactive, toRefs } from '@vue/composition-api';

import dateTypesService from '@/services/datatypes';
import useCommonModal from '@/compositions/useCommonModal';
import isEqual from 'lodash.isequal';
import Layout from '@/layouts/LayoutPopup';

export default {
  name: 'AddDataType',
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  components: {
    Layout
  },
  setup(props, { emit }) {
    const state = reactive({
      isValid: true,
      isLoading: false,
      localEntity: {
        name: '',
        description: null,
        schema: null
      },
      errors: {}
    });

    const modalComposition = useCommonModal();

    const isNew = computed(() => {
      return !props.entity.id;
    });

    const close = () => {
      emit('close');
      modalComposition.modal.hide('EditDataType');
    };

    const save = () => {
      state.isLoading = true;
      if (isNew.value) {
        dateTypesService
          .create({
            propertyType: {
              description: state.localEntity.description || null,
              schema: state.localEntity.schema || null,
              name: state.localEntity.name || null
            }
          })
          .then(() => {
            emit('update-table');
            close();
          })
          .finally(() => {
            state.isLoading = false;
          });
      } else {
        if (
          !isEqual(state.localEntity, {
            description: props.entity.description,
            schema: props.entity.schema,
            name: props.entity.name
          })
        ) {
          dateTypesService
            .update({
              id: props.entity.id,
              patch: state.localEntity
            })
            .then(() => {
              emit('update-table');
              close();
            })
            .finally(() => {
              state.isLoading = false;
            });
        } else {
          close();
        }
      }
    };

    onMounted(() => {
      if (props.entity) {
        state.localEntity.description = props.entity.description;
        state.localEntity.schema = props.entity.schema;
        state.localEntity.name = props.entity.name;
      }
    });

    return {
      ...toRefs(state),
      close,
      save,
      isNew
    };
  }
};
</script>
